// extracted by mini-css-extract-plugin
export var appLauncherSurface = "p71kX";
export var brandingLabel = "JX3ux";
export var centeredSearchBox = "bxbwb";
export var clickableTenantLogo = "YDhfp";
export var devSourceLabel = "wvicW";
export var headerCenter = "nfT_v";
export var headerCharmsAndSearch = "anQE3";
export var headerEnter = "QMgwH";
export var headerEnterActive = "uFyuc";
export var headerExit = "tslIC";
export var headerExitActive = "fnPhf";
export var headerExitDone = "FJWm2";
export var headerFullBleed = "zTtkm";
export var headerIcon = "EK67a";
export var headerIconContainer = "MCF46";
export var headerLeft = "I7Ynq";
export var headerLeftCharms = "L7fUK";
export var headerMain = "hl2hm";
export var headerMeControl = "HXOWU";
export var headerRoot = "j5qbB";
export var headerSearchBox = "Rn_96";
export var headerSearchScopePicker = "bDsVn";
export var shrinkableHeaderCharmsAndSearch = "hxUWS";
export var tenantLogo = "NcASm";
export var tenantLogoSvg = "xTFop";